import { AxiosInstance, AxiosResponse } from 'axios';

import { HTTP_STATUS } from './ErrorCode.model';
import { HttpMethod } from './HttpMethod.model';
import { isAxiosError } from './isAxiosError.guard';
import { invalidateCsrfToken } from './utils/getCsrfTokenRequest.util';

declare module 'axios' {
  export interface AxiosRequestConfig {
    csrfRetried?: boolean;
  }
}

const CSRF_PROTECTED_METHODS: string[] = [
  HttpMethod.DELETE,
  HttpMethod.PATCH,
  HttpMethod.POST,
  HttpMethod.PUT,
];

type Return = (instance: AxiosInstance, error: unknown) => Promise<AxiosResponse> | undefined;

export const retryWithFreshCsrf: Return = (instance, error) => {
  if (!isAxiosError(error) || error.response?.status !== HTTP_STATUS.FORBIDDEN) {
    return undefined;
  }

  const { config } = error;

  if (!config || config.csrfRetried) {
    return undefined;
  }

  if (!CSRF_PROTECTED_METHODS.includes(config.method ?? '')) {
    return undefined;
  }

  invalidateCsrfToken();

  return instance.request({ ...config, csrfRetried: true });
};
